module.exports = __webpack_public_path__ + "static/media/key-skeleton.4da6fe2f.svg";